<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{labelConstants.Delete}}</h4>
    <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
  </div>
  <mat-dialog-content class="">
    <p class="confirmation">{{labelConstants.AreYouSure}} <br /> {{labelConstants.Delete}}?</p>
    <img *ngIf="isImageComponent||imageSrc" [src]="imageSrc" alt=""
      onerror="this.src = '../../../assets/img/default-customer-profile.svg'" class="profile-pic-delete" />
    <p class="name WrapData">{{ action }}</p>
  </mat-dialog-content>
  <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
    <button class="btn btn-primary-outline" [mat-dialog-close]="true">{{labelConstants.Yes}}</button>
    <button class="btn btn-primary" [mat-dialog-close]="false">{{labelConstants.No}}</button>
  </div>
</div>